export default "__VITE_ASSET__DOVnON0x__"